import React, { useState } from 'react';
import { createStyles } from '@/contexts/theme-context';
import { DSRToolingActionSheet } from '@/components/orders/dsr-tooling-action-sheet';
import { ItemListOptionMetadata } from '@/contexts/item-context-types';
import { SalesRepInfo } from '@/components/orders/sales-rep-info';
import { Skeleton } from 'react-native-skeletons';
import { useNavigateToDSRTooling } from '@/hooks/use-dsr-tooling-navigation';
import { useSalesRepMode } from '@/hooks/use-sales-rep-mode';
import { useVariantPackInfoContext } from '@/contexts/variant-pack-info-context';
import { View } from 'react-native';

interface Props {
  inDraggableSheet?: boolean;
  itemMetadata: ItemListOptionMetadata;
}

const SKELETON_HEIGHT = 116;

export const InboundDetailSalesRepInfo: React.FC<Props> = (props) => {
  const salesRepMode = useSalesRepMode();

  if (!salesRepMode) {
    return null;
  }

  return <SalesRepInfoContent {...props} />;
};

const SalesRepInfoContent: React.FC<Props> = ({
  inDraggableSheet,
  itemMetadata,
}) => {
  const [styles] = useStyles();
  const navigateToDSRTooling = useNavigateToDSRTooling();
  const { variantPackDetails } = useVariantPackInfoContext();
  const [isSheetVisible, setIsSheetVisible] = useState(false);

  if (Object.keys(variantPackDetails).length === 0) {
    return (
      <View style={[styles.container, styles.skeleton]}>
        <Skeleton borderRadius={4} height={12} width={80} />
      </View>
    );
  }

  return (
    <>
      <View style={styles.container}>
        <SalesRepInfo
          inDraggableSheet={inDraggableSheet}
          onPress={() => {
            if (!navigateToDSRTooling({ itemMetadata })) {
              setIsSheetVisible(true);
            }
          }}
          variantPackUUID={itemMetadata.variantPackUUID}
        />
      </View>

      {isSheetVisible ? (
        <DSRToolingActionSheet
          itemMetadata={itemMetadata}
          onClose={() => setIsSheetVisible(false)}
        />
      ) : null}
    </>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignSelf: 'stretch',
  },
  skeleton: {
    alignItems: 'center',
    backgroundColor: theme.colors.tileColor,
    borderRadius: 8,
    height: SKELETON_HEIGHT,
    justifyContent: 'center',
  },
}));
